export default {
    notifications: [],
    loading: false,
    error: null
}
